import React from "react";
import AdminNav from "./AdminNav";
import DashboardView from "./DashboardView";


const Dashboard = () => {

  return (
    <div className="app-admin-wrap layout-sidebar-large">
      <AdminNav />

      <DashboardView />

    </div>
  )
};

export default Dashboard
